if (!window.__mtScriptsInit) {
  window.__mtScriptsInit = true;
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initGallery();
    initVariantPicker();
    initFaqAccordion();
    initMarquee();
    initHeroRotator();
    initQuickAdd();
    initCountdown();
    initQuickAddBundle();
    initAdDiscountBanner();
    initUpsellModal();
  });
}

function initUpsellModal() {
  var overlay = document.querySelector('[data-mt-upsell-overlay]');
  if (!overlay) return;

  var grid = overlay.querySelector('[data-mt-upsell-grid]');
  var closeBtn = overlay.querySelector('[data-mt-upsell-close]');
  var skipBtn = overlay.querySelector('[data-mt-upsell-skip]');
  var checkoutBtn = overlay.querySelector('[data-mt-upsell-checkout]');
  var shown = false;

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function closeModal() {
    overlay.hidden = true;
  }

  closeBtn.addEventListener('click', closeModal);
  skipBtn.addEventListener('click', goToCheckout);
  checkoutBtn.addEventListener('click', goToCheckout);
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) closeModal();
  });

  function renderProducts(products) {
    grid.innerHTML = '';
    products.slice(0, 4).forEach(function (p) {
      var variantId = p.variants && p.variants[0] ? p.variants[0].id : null;
      var card = document.createElement('div');
      card.className = 'mt-upsell-card';
      card.innerHTML =
        '<img src="' + (p.featured_image || p.images[0] || '') + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' +
        '<span class="mt-upsell-card-title">' + p.title + '</span>' +
        '<span class="mt-upsell-card-price">' + formatMoney(p.price) + '</span>' +
        '<button type="button" class="mt-upsell-card-add">Add to Cart</button>';
      var addBtn = card.querySelector('.mt-upsell-card-add');
      addBtn.addEventListener('click', function () {
        if (addBtn.hasAttribute('data-added') || !variantId) return;
        addBtn.textContent = 'Adding...';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
          .then(function (res) { return res.json(); })
          .then(function () {
            addBtn.textContent = 'Added ✓';
            addBtn.setAttribute('data-added', 'true');
            return fetch('/cart.js');
          })
          .then(function (res) { return res.json(); })
          .then(function (cart) {
            var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
            if (bubble) bubble.textContent = cart.item_count;
          })
          .catch(function () {
            addBtn.textContent = 'Error — retry';
          });
      });
      grid.appendChild(card);
    });
  }

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function openModalWithRecommendations(productId) {
    overlay.hidden = false;
    fetch('/recommendations/products.json?product_id=' + productId + '&limit=4&intent=related')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        var products = (data && data.products) || [];
        if (!products.length) {
          goToCheckout();
          return;
        }
        renderProducts(products);
      })
      .catch(function () {
        goToCheckout();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('button[name="checkout"]');
    if (!btn) return;
    if (shown || sessionStorage.getItem('mt-upsell-shown') === '1') return;

    e.preventDefault();
    e.stopPropagation();
    shown = true;
    sessionStorage.setItem('mt-upsell-shown', '1');

    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        if (!cart.items || !cart.items.length) {
          goToCheckout();
          return;
        }
        openModalWithRecommendations(cart.items[0].product_id);
      })
      .catch(function () {
        goToCheckout();
      });
  }, true);
}

function initAdDiscountBanner() {
  var banner = document.querySelector('[data-mt-ad-discount-banner]');
  if (!banner) return;

  var params = new URLSearchParams(window.location.search);
  var fromMetaAd =
    params.has('fbclid') ||
    /facebook|instagram|meta/i.test(params.get('utm_source') || '');

  if (fromMetaAd) {
    sessionStorage.setItem('mt-from-meta-ad', '1');
  }

  if (fromMetaAd || sessionStorage.getItem('mt-from-meta-ad') === '1') {
    banner.hidden = false;
  }
}

function initQuickAddBundle() {
  var buttons = document.querySelectorAll('[data-mt-quick-add-bundle]');
  if (!buttons.length) return;
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      var ids = (btn.getAttribute('data-variant-ids') || '').split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!ids.length) return;
      var originalText = btn.textContent;
      btn.disabled = true;
      btn.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          btn.textContent = 'Added ✓';
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
          if (bubble) bubble.textContent = cart.item_count;
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          btn.textContent = 'Error — try again';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        });
    });
  });
}

function initCountdown() {
  var els = document.querySelectorAll('[data-mt-countdown]');
  if (!els.length) return;

  els.forEach(function (el) {
    var hours = parseFloat(el.getAttribute('data-hours')) || 24;
    var storageKey = 'mt-countdown-' + (el.getAttribute('data-key') || 'default');
    var end = sessionStorage.getItem(storageKey);
    if (!end || parseInt(end, 10) < Date.now()) {
      end = Date.now() + hours * 60 * 60 * 1000;
      sessionStorage.setItem(storageKey, String(end));
    } else {
      end = parseInt(end, 10);
    }

    var hEl = el.querySelector('[data-mt-cd-h]');
    var mEl = el.querySelector('[data-mt-cd-m]');
    var sEl = el.querySelector('[data-mt-cd-s]');

    function tick() {
      var diff = end - Date.now();
      if (diff <= 0) {
        end = Date.now() + hours * 60 * 60 * 1000;
        sessionStorage.setItem(storageKey, String(end));
        diff = end - Date.now();
      }
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      if (hEl) hEl.textContent = String(h).padStart(2, '0');
      if (mEl) mEl.textContent = String(m).padStart(2, '0');
      if (sEl) sEl.textContent = String(s).padStart(2, '0');
    }

    tick();
    setInterval(tick, 1000);
  });
}

function initQuickAdd() {
  var buttons = document.querySelectorAll('[data-mt-quick-add]');
  if (!buttons.length) return;
  buttons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.disabled) return;
      var variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      var label = btn.querySelector('[data-mt-quick-add-label]');
      var originalText = label ? label.textContent : '';
      btn.disabled = true;
      if (label) label.textContent = 'Adding...';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Add to cart failed');
          return res.json();
        })
        .then(function () {
          if (label) label.textContent = 'Added ✓';
          return fetch('/cart.js');
        })
        .then(function (res) { return res.json(); })
        .then(function (cart) {
          var bubble = document.querySelector('.cart-count-bubble span[aria-hidden]');
          if (bubble) bubble.textContent = cart.item_count;
          var cartLink = document.getElementById('cart-icon-bubble');
          if (cartLink) {
            document.dispatchEvent(new CustomEvent('cart:refresh'));
          }
          setTimeout(function () {
            if (label) label.textContent = originalText;
            btn.disabled = false;
          }, 1500);
        })
        .catch(function () {
          if (label) label.textContent = 'Error — try again';
          setTimeout(function () {
            if (label) label.textContent = originalText;
            btn.disabled = false;
          }, 1800);
        });
    });
  });
}

function initHeroRotator() {
  var rotator = document.querySelector('[data-mt-hero-rotator]');
  if (!rotator) return;
  var frames = rotator.querySelectorAll('.mt-hero-frame');
  if (frames.length < 2) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var index = 0;
  setInterval(function () {
    frames[index].classList.remove('mt-active');
    index = (index + 1) % frames.length;
    frames[index].classList.add('mt-active');
  }, 3200);
}

function initReveal() {
  var targets = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!targets.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    targets.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );
  targets.forEach(function (el) { observer.observe(el); });
}

function initCountUp() {
  var els = document.querySelectorAll('[data-mt-countup]');
  if (!els.length) return;
  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        observer.unobserve(el);
        var target = parseFloat(el.getAttribute('data-mt-countup')) || 0;
        var decimals = (el.getAttribute('data-mt-countup').split('.')[1] || '').length;
        var duration = 1400;
        var start = null;
        function step(ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = (target * eased).toFixed(decimals);
          if (progress < 1) requestAnimationFrame(step);
          else el.textContent = target.toFixed(decimals);
        }
        requestAnimationFrame(step);
      });
    },
    { threshold: 0.4 }
  );
  els.forEach(function (el) { observer.observe(el); });
}

function initGallery() {
  var wrap = document.querySelector('[data-mt-gallery]');
  if (!wrap) return;
  var main = wrap.querySelector('[data-mt-gallery-main]');
  var thumbs = wrap.querySelectorAll('[data-mt-gallery-thumb]');
  if (!main || !thumbs.length) return;
  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      var full = thumb.getAttribute('data-mt-gallery-thumb');
      main.src = full;
      thumbs.forEach(function (t) { t.classList.remove('mt-active'); });
      thumb.classList.add('mt-active');
    });
  });
}

function initVariantPicker() {
  var form = document.querySelector('[data-mt-product-form]');
  if (!form) return;
  var dataEl = document.querySelector('[data-mt-variants-json]');
  if (!dataEl) return;
  var variants;
  try {
    variants = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }
  var idInput = form.querySelector('input[name="id"]');
  var priceEl = document.querySelector('[data-mt-price]');
  var compareEl = document.querySelector('[data-mt-compare-price]');
  var addBtn = document.querySelector('[data-mt-add-btn]');
  var selects = form.querySelectorAll('[data-mt-option-select]');
  var galleryMain = document.querySelector('[data-mt-gallery-main]');
  var galleryThumbs = document.querySelectorAll('[data-mt-gallery-thumb]');

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function findVariant() {
    var selected = Array.prototype.map.call(selects, function (s) { return s.value; });
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return opt === selected[i]; });
    });
  }

  function updateUI() {
    var variant = findVariant();
    if (!variant) return;
    idInput.value = variant.id;
    if (priceEl) priceEl.textContent = money(variant.price);
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        compareEl.textContent = money(variant.compare_at_price);
        compareEl.style.display = '';
      } else {
        compareEl.style.display = 'none';
      }
    }
    if (addBtn) {
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.setAttribute('data-mt-state', 'available');
      } else {
        addBtn.disabled = true;
        addBtn.setAttribute('data-mt-state', 'sold-out');
      }
    }
    if (variant.image && galleryMain) {
      galleryMain.src = variant.image;
      galleryThumbs.forEach(function (thumb) {
        thumb.classList.toggle('mt-active', thumb.getAttribute('data-mt-gallery-thumb') === variant.image);
      });
    }
  }

  selects.forEach(function (select) {
    select.addEventListener('change', updateUI);
  });
  updateUI();
}

function initFaqAccordion() {
  var items = document.querySelectorAll('[data-mt-faq-item]');
  if (!items.length) return;
  items.forEach(function (item) {
    var trigger = item.querySelector('[data-mt-faq-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('mt-open');
      items.forEach(function (i) { i.classList.remove('mt-open'); });
      if (!isOpen) item.classList.add('mt-open');
    });
  });
}

function initMarquee() {
  var tracks = document.querySelectorAll('[data-mt-marquee-track]');
  tracks.forEach(function (track) {
    if (track.dataset.mtCloned) return;
    track.dataset.mtCloned = 'true';
    var clone = track.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    track.parentNode.appendChild(clone);
  });
}
